import { useAxios } from "../../../../../hooks/useAxios"
import { misFacturasAdapters } from "../adapters/misFacturas.adapter"

var misFacturasServices = {

    GET: () => {

        return useAxios({ 
            method: 'get', url: '/facturacion/mis_facturas', 
            type: 'json', adapters: misFacturasAdapters.GET 
        })
    },

    GET_EXCEL: function () {

        return useAxios({ method: 'get', url: `/facturacion/mis_facturas`, type: 'blob', adapters: misFacturasAdapters.GET_EXCEL })
    },

    POST: () => {

        return useAxios({ 
            method: 'post', url: '/personas/actividades-profesionales-current-user/crear', 
            type: 'json', adapters: misFacturasAdapters.POST 
        })
    },

    PATCH: () => {

        return useAxios({ 
            method: 'patch', url: '/personas/actividades-profesionales-current-user', 
            type: 'json', adapters: misFacturasAdapters.PATCH 
        })
    },

    DELETE: () => {

        return useAxios({ 
            method: 'delete', url: '/personas/actividades-profesionales-current-user', 
            type: 'json', adapters: misFacturasAdapters.DELETE 
        })
    }
}

export {
    misFacturasServices
}